import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { useErrorToast } from '@/components/layers/ReactQueryProvider';
import { Api } from '@/core/api';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { IncidentDistinctField } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';

export const QUERY_KEY_INCIDENTS_DISTINCT_FIELD_VALUES = 'incidents-distinct-field-values';

export const useIncidentDistinctFieldValuesData = (field: IncidentDistinctField) => {
  const { orgId } = useCurrentUser();

  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_INCIDENTS_DISTINCT_FIELD_VALUES, orgId, field],
    queryFn: () => Api.mapEvents.getIncidentDistinctFieldValues({ orgId, field }),
    placeholderData: [],
  });

  useErrorToast(query);

  return {
    data,
    items: isEmpty(data) ? [] : (data as string[]),
    ...query,
  };
};
